var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 79,
    viewBox: "0 0 81 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_329_40977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6201 6.78421L49.6655 22.8537C50.2047 24.0838 51.3719 24.9266 52.7119 25.0469L69.8754 26.5859C71.8174 26.8685 72.5921 29.2501 71.184 30.6216L58.2551 41.4829C57.2083 42.3623 56.7319 43.7441 57.0198 45.0789L60.7781 62.6716C61.1079 64.6031 59.0822 66.0792 57.3443 65.1632L42.3636 56.3904C41.212 55.7152 39.7883 55.7152 38.6367 56.3904L23.6559 65.158C21.9233 66.0687 19.8924 64.5979 20.2222 62.6664L23.9804 45.0737C24.2631 43.7389 23.792 42.357 22.7451 41.4777L9.81099 30.6268C8.40818 29.2606 9.18287 26.8737 11.1196 26.5911L28.2831 25.0522C29.6231 24.9318 30.7904 24.0891 31.3295 22.859L38.375 6.78944C39.2491 5.03069 41.7511 5.03069 42.6201 6.78421Z",
    fill: "#FDD835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1067 23.8168L40.9132 11.9767C40.8661 11.3171 40.73 10.1865 41.7874 10.1865C42.6249 10.1865 43.0803 11.9296 43.0803 11.9296L46.6606 21.4352C48.0111 25.0521 47.4562 26.2927 46.1529 27.0255C44.6558 27.863 42.4469 27.2087 42.1067 23.8168Z",
    fill: "#FFFF8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.873 40.4311L67.1429 32.4173C67.6506 31.9933 68.5666 31.318 67.8338 30.5486C67.2528 29.9414 65.6825 30.8155 65.6825 30.8155L56.6951 34.3278C54.0151 35.2543 52.2354 36.6257 52.0783 38.353C51.8742 40.6562 53.9418 42.4306 56.873 40.4311Z",
    fill: "#F4B400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_329_40977",
    x: 0.0947266,
    y: 0.469727,
    width: 80.8096,
    height: 77.9717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_329_40977"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_329_40977",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiStar);
export default __webpack_public_path__ + "static/media/emoji-star.1d633b829e6c3f477356f214344e635a.svg";
export { ForwardRef as ReactComponent };